import Block from "quill/blots/block";
import Inline from 'quill/blots/inline';
import Embed from 'quill/blots/embed';

class ImageBlot extends Embed {
    static blotName = 'imageCustom';
    static tagName = 'div';
    static className = 'image-custom';

    static create(value: { url: string, alt?: string, class?: string }) {
        const node = super.create(value) as HTMLElement;

        const img = document.createElement('img');
        img.setAttribute('src', value.url);

        if (value.alt) img.setAttribute('alt', value.alt);
        if (value.class) img.classList.add(value.class);

        node.appendChild(img);
        return node;
    }

    static value(node: HTMLElement) {
        const img = node.querySelector('img');
        return {
            url: img?.getAttribute('src') || '',
            alt: img?.getAttribute('alt') || undefined,
            class: img?.className || undefined
        };
    }

    static formats(node: HTMLElement) {
        const img = node.querySelector('img');
        return {
            alt: img?.getAttribute('alt'),
            class: img?.className
        };
    }
}

export default ImageBlot;